
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {IHome} from "@/modules/Home/interfaces/home.interface";
  import ShortCarSecurity from "@/modules/CarList/components/AntiTheftComponents/ShortCarSecurity.vue";
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import {antiTheftCars} from "@/modules/CarList/mixins/antitheft.class";
  import {bus} from "@/plugins/bus";
  import moment from "moment";
  import {isMobile} from "mobile-device-detect";
  import CarNumber from "@/components/CarNumber.vue";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import {AntiTheftActions} from "@/modules/CarList/mixins/anti-theft-actions.mixin";
  import {ICar} from "@/modules/Car/interfaces/car.interface";

  @Component({
    components: {
      CarNumber,
      ShortCarSecurity,
    },
  })
  export default class CarCar extends Vue {
    @Prop() car: IHome.IFavoriteCar;

    carPopupTabs = ICar.CarPopupTab;
    carSecurity: IAntiTheft.IStatusCars = null;
    time = '';
    timeInterval = null;
    isMobile = false;

    get noParking(): boolean { return !Boolean(this.car.dateBeg); }

    async mounted () {
      this.isMobile = isMobile;

      this.presetData();

      bus.$on(IAntiTheft.BusEvents.GetCars, this.presetData);

      this.calculateTime();
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
      }
      this.timeInterval = setInterval(() => {
        this.calculateTime();
      }, 1000);
    }

    async openCarPopup(car: IAntiTheft.IStatusCars, tabForOpen: ICarPopupTables.CarPopupTab) {
      let payload: ICarStore.IPopupPayload = {
        carId: car.carId,
        tabForOpen,
        closeAction: async () => {
          bus.$emit(IHome.EmitterEvents.UpdateCarInfo);
        },
      };
      await this.$store.dispatch('car/openCarPopup', payload);
      this.$emit('openCarPopup');
    }

    async toggleStatus(value, car: IAntiTheft.IStatusCars) {
      car.theftFlag = !car.theftFlag;
      await AntiTheftActions.changeStatus(this, {
        carId: car.carId,
        securityActive: car.theftFlag,
        scheduleActive: car.theftScheduleFlag,
      });

      this.$notify({
        title: car.theftFlag ? 'Поставлен на охрану' : 'Снят с охраны',
        message: 'Вы можете задать расписание в карточке автомобиля.',
        type: 'success'
      });
    }

    async presetData() {
      let cars = antiTheftCars.cars;
      this.carSecurity = cars.find(car => car.carId === this.car.carId);
    }

    calculateTime() {
      if (this.car.dateBeg) {
        let serverTime = Math.ceil(+moment(this.car.dateBeg).format('x') / 1000);
        let currTime = Math.ceil(+moment().format('x') / 1000);
        this.time = this.printTimeString(+currTime - +serverTime);
      }
    }

    printTimeString(period) {
      let days: any = Math.floor(period / 86400);
      let hours: any = Math.floor((period - days * 86400) / 3600);
      let minutes: any = Math.floor((period - days * 86400 - hours * 3600) / 60);
      let seconds: any = period - days * 86400 - hours * 3600 - minutes * 60;

      if (hours < 10) hours = '0' + hours;
      if (minutes < 10) minutes = '0' + minutes;
      if (seconds < 10) seconds = '0' + seconds;

      let result = `${days > 0 ? days + ' д. ' : ''}${hours}:${minutes}:${seconds}`;
      return result;
    }

    destroyed() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
      }
    }
  }
